import { ProcessedPostLogRow, RawPostLogRow } from './process-logs-constants';

export const aggregatePostLogs = (rows: RawPostLogRow[]): ProcessedPostLogRow[] => {
  const grouped = new Map<string, ProcessedPostLogRow>();

  for (const row of rows) {
    const key = `${row.company}_${row.network}_${row.satelliteNetwork}_${row.length}`;
    const existing = grouped.get(key);
    grouped.set(key, {
      company: row.company,
      network: row.network,
      satelliteNetwork: row.satelliteNetwork,
      length: row.length,
      count: (existing?.count ?? 0) + 1,
      spend: (existing?.spend ?? 0) + row.cost
    });
  }

  return [...grouped.values()].sort((a, b) => a.company.localeCompare(b.company));
};

export const computePostLogTotals = (
  rows: ProcessedPostLogRow[]
): { count: number; spend: number } => ({
  count: rows.reduce((sum, row) => sum + row.count, 0),
  spend: rows.reduce((sum, row) => sum + row.spend, 0)
});

export const getUniqueCompanies = (rows: ProcessedPostLogRow[]): string[] => [
  ...new Set(rows.map(row => row.company))
];

export const getAcceptKey = (buildId: string, week: string, company: string): string =>
  `${buildId}|${week}|${company}`;
